<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          @change="saveDisabled=false"
          label="Visible"
          v-model="navButtonsSettings.visible"
        ></v-checkbox>
        <small>Hide or show the 'News' and 'Social' button under the appbar</small>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn
          :disabled="saveDisabled"
          class="mr-3"
          @click="updateSocialSettings"
          color="success"
        >Save</v-btn>
        <v-btn @click="loadSettings" color="info">Cancel</v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navButtonsSettings: {
        visible: false
      },
      saveDisabled: true
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    loadSettings: function() {
      this.navButtonsSettings = { ...(this.$store.state.settings.settings.navButtons) };
      this.saveDisabled = true;
    },
    updateSocialSettings: function() {
      this.$store
        .dispatch("settings/patch", this.navButtonsSettings)
        .then(() => {
          this.saveDisabled = true;
        });
    }
  }
};
</script>
